export const getValueByProp = (prop: string, propVal: any, data: any, r?: any): { status: boolean, result?: any } => {
    r = r ? r : {status: false};
    if (!data) return r;
    if (!prop || !propVal) return r;
    if (data[prop] && data[prop] === propVal) {
        r.result = data;
        r.status = true;
        return r;
    }
    for (let i in data) {
        if (data[i] && typeof data[i] === 'object') {
            const tmp = getValueByProp(prop, propVal, data[i], r);
            if (tmp.status) return tmp;
        }
    }
    return r;
};
